import { apiGet } from '../api.ts'
import { useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'
import { IPagingReq, IPagingRes } from '@/api/paging.ts'
import { createUrl } from '@/util/url.ts'
import { IPosition } from '@/api/user/getUsers.ts'

interface IReqGetUrgentHistory extends IPagingReq {

}

export const apiGetNotificationFalldetection = async ({ pageNum, pageSize }: IReqGetUrgentHistory, query?: string) => {
    return await apiGet<IPagingRes<IAlertFalldetection[]>>(createUrl('/alert/falldetection', {
        query: query,
        pageNum: pageNum,
        pageSize: pageSize
    }))
}

const useQueryGetNotificationFalldetection = (props: IReqGetUrgentHistory, query?: string) => {
    return useQuery({
        queryKey: QueryCacheKeys.notification.apiGetNotificationFalldetection(query),
        queryFn: async () => {
            const { data } = await apiGetNotificationFalldetection(props, query)
            return data
        }
    })
}

export default useQueryGetNotificationFalldetection

export interface IAlertFalldetectionProtectee {
    id: number;
    name: string;
    gender: string;
    birthDate: string;
    contact: string;
    memo: string;
}


export interface IAlertFalldetectionAlert {
    name: string;
    nameDetail?: IAlertStateDetail;
    managerName: string;
    confirm: FalldetectionAlertConfirmStatus;
    result?: any;
    content?: string;
    isMyTask?: boolean;
    taskCheckAt?: string;
    taskManagerAt?: string;
    createdAt: string;
    checkedAt?: any;
    location: IPosition;
}

export interface IAlertFalldetection {
    id: number;
    protectee: IAlertFalldetectionProtectee;
    protector: IAlertFalldetectionProtector;
    alert: IAlertFalldetectionAlert;
}

export interface IAlertFalldetectionProtector {
    relation?: string;
    contact?: string;
    secondaryRelation?: string;
    secondaryContact?: string;
    tertiaryRelation?: string;
    tertiaryContact?: string;
}

export interface IAlertStateDetail {
    resp: number;
    hrate: number;
    respStatus: string;
    hrateStatus: string;
}

export enum FalldetectionAlertConfirmStatus {
    WAIT = '미처리',
    ASSIGN = '담당자 배정',
    DONE = '처리'
}